import { STORAGE_PREFIX } from './brand';

const TOKEN_KEY = `${STORAGE_PREFIX}-token`;
const AUTH_STORE_KEY = `${STORAGE_PREFIX}-auth`;
const LEGACY_TOKEN_KEY = 'certedu-token';
const LEGACY_AUTH_STORE_KEY = 'certedu-auth';

function readLegacyToken(): string | null {
  const direct = localStorage.getItem(LEGACY_TOKEN_KEY);
  if (direct) return direct;

  try {
    const raw = localStorage.getItem(LEGACY_AUTH_STORE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { state?: { token?: string | null } };
    return parsed.state?.token ?? null;
  } catch {
    return null;
  }
}

/** Lit le JWT depuis localStorage ou le store Zustand persisté. */
export function getAuthToken(): string | null {
  const direct = localStorage.getItem(TOKEN_KEY);
  if (direct) return direct;

  try {
    const raw = localStorage.getItem(AUTH_STORE_KEY);
    if (!raw) return readLegacyToken();
    const parsed = JSON.parse(raw) as { state?: { token?: string | null } };
    return parsed.state?.token ?? readLegacyToken();
  } catch {
    return readLegacyToken();
  }
}

export function hasAuthToken(): boolean {
  return Boolean(getAuthToken());
}

export function setAuthToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);

  try {
    const raw = localStorage.getItem(AUTH_STORE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as { state?: Record<string, unknown> };
    if (!parsed.state) return;
    parsed.state.token = token;
    parsed.state.isAuthenticated = true;
    localStorage.setItem(AUTH_STORE_KEY, JSON.stringify(parsed));
  } catch {
    // Le store Zustand resynchronisera au prochain chargement.
  }
}

/**
 * Attaches a token to outgoing requests without marking the session as
 * authenticated in the persisted store. Used for silent device-guest
 * sessions so the "sign up after N free exams" gate keeps working.
 */
export function setAuthTokenSilently(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAuthStorage() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);

  try {
    const raw = localStorage.getItem(AUTH_STORE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as { state?: Record<string, unknown> };
    if (!parsed.state) return;
    parsed.state.token = null;
    parsed.state.isAuthenticated = false;
    parsed.state.user = null;
    localStorage.setItem(AUTH_STORE_KEY, JSON.stringify(parsed));
  } catch {
    localStorage.removeItem(AUTH_STORE_KEY);
  }

  localStorage.removeItem(LEGACY_AUTH_STORE_KEY);
}
